import server from 'common/utils/server';
import {
  startCoachingSessionRequest,
  finishCoachingSessionRequest,
  formatPrivateNote
} from './coachingSession';

export const getCoachingSessionPrivateNote = coachingSessionId => dispatch => {
  dispatch(startCoachingSessionRequest());
  server
    .get(`/api/v1/coaching/coaching_session/${coachingSessionId}/private_note`)
    .then(privateNoteJSON => {
      const privateNote = formatPrivateNote(privateNoteJSON);
      dispatch({
        type: 'SET_PRIVATE_NOTE',
        privateNote,
      });
      dispatch(finishCoachingSessionRequest());
    });
};

export const updateCoachingSessionPrivateNote = (
  coachingSessionId,
  notes
) => dispatch => {
  dispatch(startCoachingSessionRequest());
  server
    .put(
      `/api/v1/coaching/coaching_session/${coachingSessionId}/private_note`,
      { notes }
    )
    .then(privateNoteJSON => {
      const privateNote = formatPrivateNote(privateNoteJSON);
      dispatch({
        type: 'SET_PRIVATE_NOTE',
        privateNote,
      });
      dispatch(finishCoachingSessionRequest());
    });
};

export const coachingSessionPrivateNote = (state = {}, action) => {
  switch (action.type) {
    case 'LOADED_COACHING_SESSION': {
      const { privateNote } = action;
      return privateNote;
    }
    case 'SET_PRIVATE_NOTE': {
      const { privateNote } = action;
      return privateNote;
    }
    default: {
      return state;
    }
  }
};
